import ImageNonResponsive from "components/atoms/ImageNonResponsive";
import Syllables from "components/molecules/Syllables";
import PropTypes from "prop-types";
import { navigateToLessonsPlan } from "utils/navigateToLessonsPlan";
import "./styles.scss";

const Story = ({ card, baseUrl }) => {
  const sentences = card?.story?.replaceAll(/\. /gi, ".").split(".");
  return (
    <div className="story">
      <div
        className="close-button"
        onClick={() => navigateToLessonsPlan(baseUrl)}
      >
        &nbsp;
      </div>
      <span className="title">{card?.title}</span>
      <ImageNonResponsive
        className="story-image-block"
        imageClassName="story-image"
        filename={`stories/${card?.picture}`}
      />
      {sentences?.map((sentence, index) => {
        return (
          <div className="sentence" key={`sentence-${index}`}>
            {sentence?.split(" ").map((word, index) => {
              const isSimplePicture = word.includes("|");
              const simplePictureCaption = word.split("|")?.[0];
              const picturePath = word.split("|")?.[1];
              return !isSimplePicture ? (
                <span className="word" key={`word-${index}`}>
                  <Syllables
                    word={word}
                    type={"read-sentence"}
                    lettersVsPicsProbability={100}
                    isInASentence={true}
                  />
                </span>
              ) : (
                <div className="simple-picture" key={`simple-picture-${index}`}>
                  <ImageNonResponsive
                    filename={`${picturePath}-300`}
                  />
                  <span>{simplePictureCaption}</span>
                </div>
              );
            })}
          </div>
        );
      })}
      <ImageNonResponsive
        className="story-image-end"
        filename={`stories/${card?.picture}-end`}
      />
    </div>
  );
};

Story.propTypes = {
  card: PropTypes.shape({
    title: PropTypes.string,
    picture: PropTypes.string,
    story: PropTypes.string,
  }),
  baseUrl: PropTypes.string,
};

export default Story;
